import * as React from 'react';
import * as Sentry from '@sentry/react';

import { Heading, Text } from 'common/typography';
import { Content, Page } from 'common/layout';

import { ExtendedButton, ButtonContainer } from './styled';

export const SentryFallback: React.FC<SentryFallbackProps> = ({
  eventId, handleDialog,
}) => {
  return (
    <Page>
      <Page.Content>
        <Content>
          <Heading as="h2">
            Er heeft zich een probleem voorgedaan!
          </Heading>
          <Text>
            Ons team is op de hoogte gebracht, maar om ons extra te helpen kunt u ook een melding maken van het probleem. Als u ons uitlegt wat u precies wilde doen, kunnen wij ervoor zorgen dat het in de toekomst niet nogmaals voorkomt.
          </Text>
          <ButtonContainer>
            <ExtendedButton variant="yellow" onClick={() => window.location.href = '/'}>
              Terug
            </ExtendedButton>
            <ExtendedButton variant="blue" onClick={() => handleDialog(eventId)}>
              Meld het probleem!
            </ExtendedButton>
          </ButtonContainer>
        </Content>
      </Page.Content>
    </Page>
  );
};

type SentryFallbackProps = {
  eventId: EventIdType;
  handleDialog: (eventId: EventIdType) => void;
};

export const SentryBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const handleDialog = (eventId: EventIdType) => {
    if (!eventId) return;

    Sentry.showReportDialog({
      eventId,
      lang: 'nl',
      title: 'Er heeft zich een probleem voorgedaan!',
      subtitle: 'Bedankt dat u ons wilt helpen met het oplossen van dit probleem.',
      subtitle2: 'Vul het formulier in om ons te helpen het op te lossen!',
      labelName: 'Naam',
      labelEmail: 'E-mail',
      labelClose: 'Annuleren',
      labelComments: 'Wat is er gebeurd?',
      labelSubmit: 'Verstuur',
      successMessage: 'Bedankt voor uw bijdrage om het platform te verbeteren! We gaan er z.s.m. naar kijken. Mochten er vragen zijn n.a.v. uw melding, dan nemen we contact met u op.',
    });
  };

  return (
    <Sentry.ErrorBoundary
      fallback={({ eventId }) => <SentryFallback {...{ eventId, handleDialog }} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

type EventIdType = string | null;
